@if (!hideFooter) {
  <div class="content-wrapper">
    <div class="app-footer px-3">
      <div class="app-links flex-grow-1 justify-content-start">
        @for (link of links; track link) {
          <a
            [id]="'link_' + link.text"
            [href]="link.href | translate"
            target="_blank"
            rel="noopener"
            class="footer-link"
            >{{ link.text | translate }}</a
            >
          }
        </div>
        <ix-typography id="footerVersion" format="body" color="soft">
          {{ 'dpp.general.version' | translate: { version: version } }} &nbsp; &nbsp;
          {{ 'dpp.general.copyright' | translate: { year } }}
        </ix-typography>
      </div>
    </div>
}
